import { UserIdSchema } from "@core/domains/identity";
import { createModel, createModelSchemas } from "@core/foundation/model";
import { z } from "@core/zod";

import { ReservationIdSchema } from "./reservation.ts";

const ReservedBalanceEntrySchema = z.object(
  { amount: z.decimal().positive(), expiresAt: z.iso.datetime() },
  {
    amount: "The credit the hold takes, as a decimal string.",
    expiresAt: "When the hold expires, as an ISO 8601 timestamp.",
  },
);

export const ReservedBalance = createModel({
  create: (item, schema) => {
    return { ...schema.decode(item), etag: null };
  },
  schemas: createModelSchemas({
    model: z.object(
      {
        etag: z.string().nullable(),
        holds: z.record(ReservationIdSchema, ReservedBalanceEntrySchema),
        principalId: UserIdSchema,
      },
      {
        etag: "The record's version, which storage stamps for concurrency.",
        holds:
          "The held amounts, keyed by the id of the reservation holding each.",
        principalId: "The id of the user whose holds the record carries.",
      },
    ),
    modelCreate: ({ readSchema }) => readSchema.omit({ etag: true }),
    modelUpdate: ({ schema }) => schema.pick({ holds: true }).partial(),
  }),
  update: (item, update, schema) => {
    return { ...item, ...schema.decode(update) };
  },
});

export interface ReservedBalance
  extends z.infer<typeof ReservedBalance.schema> {}
